import { Attachment } from "../components/operation/inbox/InboxList";
import { ackNotificationRequest, assignNotificationRequest, composeNotificationRequest, deleteNotificationRequest, getAlertRecordNumbers, getNotificationsByRefEntsRequest, SentboxRequest } from "../redux/slice/inbox/createNotificationSlice";
import { GET_NOTIFICATION_LIST, SAVE_USER_SENT_NOTIFICATION, ACK_NOTIFICATION, GET_NOTIFS_BY_REF_ENTITIES, GET_ALERT_ENTITITY_NUMBERS, ASSIGN_NOTIFICATION, GET_IMPORTANT_UNREAD_NOTIFICATIONS, ACK_ALL_NOTIFICATIONS, DELETE_NOTIFICATION_BY_ID, DELETE_ALL_NOTIFICATIONS, GET_ALL_SENT_MESSAGES, UPLOAD_NOTIFICATION_DOCUMENT_URL, REMOVE_NOTIFICATION_DOCUMENTS_URL } from "./URL";
import { http } from "./http";

export const getNotificationList = async (data: any) => {
  try {
    const response = await http.post(GET_NOTIFICATION_LIST, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const sendUserNotification = async (data: composeNotificationRequest) => {
  try {
    const response = await http.post(SAVE_USER_SENT_NOTIFICATION, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveNotificationDocument = async (data: Attachment) => {
  try {
    const response = await http.post(UPLOAD_NOTIFICATION_DOCUMENT_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteNotificationDocuments = async (data: number[]) => {
  try {
    const response = await http.post(REMOVE_NOTIFICATION_DOCUMENTS_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ackNotification = async (data: ackNotificationRequest) => {
  try {
    const response = await http.post(ACK_NOTIFICATION, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ackAllNotifications = async (data: any) => {
  try {
    const response = await http.post(ACK_ALL_NOTIFICATIONS, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getNotificationsByRefEntities = async (data: getNotificationsByRefEntsRequest) => {
  try {
    const response = await http.post(GET_NOTIFS_BY_REF_ENTITIES, data);
    return response;
  } catch (error) {
    throw error;
  }
};


export const getNotificationsByRefEntitiesSkipLoading = async (data: getNotificationsByRefEntsRequest, headers: Record<string, string>) => {
  try {
    const response = await http.post(GET_NOTIFS_BY_REF_ENTITIES, data, { headers: {...headers} });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAlertedRecordNumbers = async (data: getAlertRecordNumbers) => {
  try {
    const response = await http.post(GET_ALERT_ENTITITY_NUMBERS, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAlertedRecordNumbersSkipLoading = async (data: getAlertRecordNumbers, headers: Record<string, string>) => {
  try {
    const response = await http.post(GET_ALERT_ENTITITY_NUMBERS, data, {headers: {...headers}});
    return response;
  } catch (error) {
    throw error;
  }
};

export const assignNotificationToAnother = async (data: assignNotificationRequest) => {
  try {
    const response = await http.post(ASSIGN_NOTIFICATION, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getImportantNotifications = async () => {
  try {
    const response = await http.post(GET_IMPORTANT_UNREAD_NOTIFICATIONS);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteNotificationById = async (data: deleteNotificationRequest) => {
  try {
    const response = await http.post(DELETE_NOTIFICATION_BY_ID, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteAllNotificationsByUser = async () => {
  try {
    const response = await http.post(DELETE_ALL_NOTIFICATIONS);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllSentMessageList = async (data: SentboxRequest) => {
  try {
    const response = await http.post(GET_ALL_SENT_MESSAGES, data);
    return response;
  } catch (error) {
    throw error;
  }
};